import { useEffect, useId, useRef } from 'react';
import { useAuthContext } from './context';
import controls from './controls.module.css';
import { ROLE_LABELS } from './messages';
import styles from './UserMenu.module.css';
import { useLogout } from './useLogout';

/** Quem está conectado (nome e papel) e o botão "Sair". */
export function UserMenu() {
  const { state } = useAuthContext();
  const { logout, pending, error } = useLogout();
  const errorId = useId();
  const buttonRef = useRef<HTMLButtonElement>(null);

  // O botão fica desabilitado durante o pedido e o navegador pode soltar o foco dele; quando
  // o logout falha, devolve o foco para quem usa teclado tentar de novo sem procurar o botão.
  useEffect(() => {
    if (error) buttonRef.current?.focus();
  }, [error]);

  if (state.status !== 'authenticated') return <></>;
  const { user } = state;

  return (
    <section className={styles.menu} aria-label="Conta">
      <p className={styles.identity}>
        <span className={styles.name}>{user.name}</span>{' '}
        <span className={styles.role}>{ROLE_LABELS[user.role]}</span>
      </p>
      <button
        type="button"
        ref={buttonRef}
        className={`${controls.secondary} ${styles.button}`}
        onClick={logout}
        disabled={pending}
        aria-describedby={error ? errorId : undefined}
      >
        {pending ? 'Saindo…' : 'Sair'}
      </button>
      {error && (
        <p id={errorId} role="alert" className={styles.error}>
          {error}
        </p>
      )}
    </section>
  );
}
